import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Search, Label, Segment } from 'semantic-ui-react';
import { tagType } from '../types';

const propTypes = {
  onSelection: PropTypes.func.isRequired,
  initialTag: PropTypes.string,
  tagGroups: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isReqruied,
    tags: PropTypes.arrayOf(tagType).isrequired,
  })).isRequired,
  selectedTags: PropTypes.arrayOf(PropTypes.string),
  view: PropTypes.string.isRequired,
};

const defaultProps = {
  initialTag: '',
  selectedTags: [],
};

function highlight(text, searchStr) {
  const commaString = text.replace(
    new RegExp(`(${searchStr})`, 'gi'),
    (match, p1, offset, string) => {
      if (offset === 0) return `${match},`;
      if (offset + match.length < string.length) return `,${match},`;
      return `,${match}`;
    },
  );
  return commaString.split(',').map((str, index) => {
    if (str.toLowerCase() === searchStr.toLowerCase()) {
      return (
        <span key={searchStr + index} style={{ backgroundColor: 'rgba(255,255,0,0.3)' }}>{str}</span>
      );
    }
    return <span key={searchStr + index}>{str}</span>;
  });
}

class EditorTagSearch extends Component {
  constructor(props) {
    super(props);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.resetComponent = this.resetComponent.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentWillMount() {
    this.resetComponent(this.props.initialTag);
  }

  resetComponent(startingVal) {
    this.setState({ results: [], value: startingVal });
  }

  handleResultSelect(e, { result }) {
    if (this.props.selectedTags.includes(result._id)) return;

    if (this.props.view === 'resources') {
      this.props.onSelection(result);
      this.setState({ value: '' });
    } else {
      this.props.onSelection(result.title);
      this.setState({ value: result.title });
    }
  }

  handleSearchChange(e, { value }) {
    const { tagGroups } = this.props;

    const isMatch = tag => (tag.display.toLowerCase().includes(value.toLowerCase()));
    let filteredResults =
      tagGroups
        .map(tagGroup => ({
          key: tagGroup._id,
          _id: tagGroup._id,
          title: tagGroup.name,
          tags: tagGroup.tags.filter(isMatch),
        }));
    filteredResults = filteredResults.filter(tagGroup =>
      (tagGroup.tags.length > 0) || tagGroup.title.toLowerCase().includes(value.toLowerCase()));

    if (this.props.view === 'tags') this.props.onSelection(value);
    return this.setState({
      value,
      results: filteredResults,
    });
  }

  render() {
    const { value, results } = this.state;
    const { selectedTags } = this.props;
    const searchStr = value && value.length ? value : '';
    return (
      <Search
        id="synonymSelect"
        fluid
        onResultSelect={this.handleResultSelect}
        onSearchChange={this.handleSearchChange}
        results={results.slice(0, 10)}
        value={searchStr}
        resultRenderer={({ title, tags, _id }) => {
          const disabled = selectedTags.includes(_id);
          return (
            <Segment raised>
              <Label color={disabled ? 'teal' : 'grey'} size="small" ribbon>{highlight(title, searchStr)}</Label>
              {tags.map(tag => (
                <Label
                  key={`${title}.${tag.display}`}
                  size="tiny"
                >
                  {highlight(tag.display, searchStr)}
                </Label>
              ))}
            </Segment>
          );
        }}
      />
    );
  }
}

EditorTagSearch.propTypes = propTypes;
EditorTagSearch.defaultProps = defaultProps;
export default EditorTagSearch;



// WEBPACK FOOTER //
// ./src/components/EditorTagSearch.jsx